import React, { useEffect, useState } from 'react';
import { Box, Card, Typography } from '@mui/material';
import RouteConstants from '../../constants/routeConstants';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import {
List,
// ListItem,
// ListItemIcon,
// ListItemText,
CircularProgress,
} from '@mui/material';
import Title from '../../sharedcomponents/title/title';
const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const MyResource = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfos = Helper.getStorage('userInfo');
        const gAgentInfo=Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        setLoading(true);
        ApiHelper.get(
            APIURLConstants.GET_MY_RESOURCE(eventInfo.eventID, agentConnection && gAgentInfo? gAgentInfo.userID:userInfos.userID)
        ).then((res) => {
            setLoading(false);

            if (res.data.resources) {
                let data = res.data.resources;
                if (data.length > 0) {
                    setData(data);
                }
            }
        });
    }, []);
    const multipleFileDownload = (value) => {
        console.log(value)
        value.map((val) => {
            window.open(val);
        });
    }
    return (
        <>
            {loading ? (
                <Box sx={loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className="contentBox">
                    <Box
                        sx={{
                            width: '100%',
                            backgroundColor: '#fff',
                            '& .MuiFormControl-root': { width: '100%' },
                        }}>
                        <Box sx={{ p: 2 }}>
                            <Title title="Event Documents" />
                        </Box>
                        <Box component="div">
                            <List dense={true}>
                                {data.map((row, index) => {
                                    const splitUrl = (row.publicUrl !== null) ? row.publicUrl.split(',') : "";
                                    return (
                                        <Card key={`resource_${index}`} sx={{mb:2, boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',}}>
                                            <Box sx={{
                                                        display:'flex',
                                                        flexDirection:'row'
                                                    }}>
                                                        <Box sx={{
                                                                p:2, 
                                                                display:'flex',
                                                                flexDirection:'row',
                                                                cursor: 'pointer',
                                                                width: '30%'
                                                            }}
                                                            onClick={() => {
                                                                if (row.publicUrl !== '') {
                                                                    multipleFileDownload(splitUrl)
                                                                }
                                                            }}
                                                            >
                                                            <FileCopyOutlinedIcon
                                                                fontSize="small"
                                                                color="primary"
                                                            />
                                                            <Typography sx={{pl:1}}>{ row.resourceName}</Typography>
                                                        </Box>
                                                        <Box 
                                                            sx={{
                                                                p:2, 
                                                                display:'flex',
                                                                flexDirection:'row',
                                                                width: "70%"
                                                            }} 
                                                            dangerouslySetInnerHTML={{__html: row.description && row.description}}
                                                        > 
                                                        </Box>
                                                    </Box>
                                            {/* <ListItem
                                                key={`resource_${index}`}
                                                sx={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    if (row.publicUrl !== '') {
                                                        multipleFileDownload(splitUrl)
                                                    }
                                                }
                                                }>
                                                <ListItemIcon>
                                                    <FileCopyOutlinedIcon
                                                        fontSize="small"
                                                        color="primary"
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={row.resourceName}
                                                /> 
                                                <Typography>{ row.resourceName}</Typography>
                                            </ListItem> */}
                                            
                                        </Card>
                                    )
                                })}
                            </List>
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default {
    routeProps: {
        path: RouteConstants.MY_RESOURCE,
        component: MyResource,
    },
    name: 'MyResource',
};
